import { useEffect, useState } from "react";
import { Button } from "components/atoms";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import "./index.scss";
dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

interface IProps {
  startTime: string;
  endTime: string;
  segmentId: number;
  btnUrl?: string;
  index: number;
  onClick: (segmentId: number) => void;
  handleRemove: (segmentId: number) => void;
  isLoading: boolean;
  isLoadingRemove: boolean;
  isFetchingData?: boolean;
  activeSegment?: any;
}

export const ConditionalTopicFocusPageBtns = ({
  startTime,
  endTime,
  segmentId,
  btnUrl,
  index,
  onClick,
  isLoading,
  handleRemove,
  isLoadingRemove,
  isFetchingData,
  activeSegment,
}: IProps) => {
  const [isTopicFocusSegmentBtnEnable, setIsTopicFocusSegmentBtnEnable] =
    useState(false);

  useEffect(() => {
    const fifteenMinsBeforeTime: any = dayjs
      .utc(startTime)
      .local()
      .subtract(15, "m");

    const interval = setInterval(() => {
      if (
        dayjs().isSameOrAfter(fifteenMinsBeforeTime) &&
        dayjs().isSameOrBefore(dayjs.utc(endTime).local())
      ) {
        setIsTopicFocusSegmentBtnEnable(true);
      } else {
        setIsTopicFocusSegmentBtnEnable(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, endTime]);

  if (isTopicFocusSegmentBtnEnable) {
    return (
      <div className="btn-wrapper">
        <Button
          onClick={() => {
            window.open(btnUrl, "_blank");
          }}
          label="Launch Class"
          type="active"
          icon={false}
          btnId={`home-btn-${index}`}
          isDisable={btnUrl ? false : true}
        />
      </div>
    );
  } else {
    return (
      <div className="btn-wrapper">
        <Button
          onClick={() => {
            if (!isLoadingRemove && !isFetchingData) {
              handleRemove(segmentId);
            }
          }}
          label="Remove from Coursework"
          type="active"
          icon={false}
          btnId={`home-btn-${index}`}
          isLoading={
            (isLoadingRemove && activeSegment === segmentId) || (isFetchingData && activeSegment === segmentId)
          }
        />
      </div>
    );
  }
};
